export const environment = {
  production: true,
  hmr: false,
  apiUrl: 'https://business.dev2.mytitle.com',
};
